import {atom} from 'jotai';
import type {Stockist} from './types';

export const countrySelectModalAtom = atom(false);
export const countriesWithoutShippingModalAtom = atom(false);

export const getShippingUpdatesFormDialogAtom = atom(false);
export const countryWeShipToDialogAtom = atom(false);
export const countryManagedByDistributorDialogAtom = atom(false);
export const countryWithoutShippingDialogAtom = atom(false);

export const selectedMarkerAtom = atom<Stockist | null>(null);
